import type {assetListSchema, assetSchema} from '../utils/schemas/asset';
import type {layoutSchema} from '../utils/schemas/layout';
import type {z} from 'zod';

export type Asset = z.infer<typeof assetSchema>;
export type AssetElement = z.infer<typeof assetListSchema.element>;

export type LayoutInstance = z.infer<typeof layoutSchema>;

export enum AssetType {
  Building,
  Ship,
  Flare,
  CoolingTower,
  Bridge,
  CellTower,
  WaterTank,
  OilTank,
  FuelTank,
  PowerLine,
  PipeLine,
  Reactor,
  Boiler,
  Chimney,
  Furnace,
  ConfinedSpace,
  CrackerUnit,
  Miscellaneous,
}
